import { AxiosResponse } from 'axios'

import { instanceMainService } from '../api.instance'
import { TransformPayloadReturnT, transformPayload } from '../api.helpers'

import { REDEEM_URLS } from './redeem.constants'

import { IGetRedeemListRequest, IGetRedeemRewardListRequest, IRedeemData, IRedeemReward } from './redeem.types'
import { IRequestRedeemEvent, IResponse, WrappedResponse } from 'primsell-shared-layer/types'
import { replaceUrlParams } from 'primsell-shared-layer/utils'

export class RedeemAPI {
  static getRedeems(payload: IGetRedeemListRequest): Promise<WrappedResponse<IRedeemData[]>> {
    const transformedPayload: TransformPayloadReturnT = transformPayload(payload)

    return instanceMainService.get(REDEEM_URLS.REDEEMS, { params: transformedPayload })
  }

  static getRedeemById(id: string): Promise<WrappedResponse<IRedeemData>> {
    return instanceMainService.get(replaceUrlParams(REDEEM_URLS.REDEEM_BY_ID, { id }))
  }

  static redeemEvent(payload: IRequestRedeemEvent): Promise<AxiosResponse<IResponse<any>>> {
    const { code, ...rest } = payload
    return instanceMainService.post(replaceUrlParams(REDEEM_URLS.REDEEM_EVENT, { code }), rest)
  }

  static redeemRewardEvent(payload: IRequestRedeemEvent): Promise<AxiosResponse<IResponse<any>>> {
    const { code, ...rest } = payload
    return instanceMainService.post(replaceUrlParams(REDEEM_URLS.REDEEM_REWARD_EVENT, { code }), rest)
  }

  static getRedeemsCSV(payload: Exclude<IGetRedeemListRequest, 'pagination'>): Promise<AxiosResponse<string>> {
    const transformedPayload: TransformPayloadReturnT = transformPayload(payload)

    return instanceMainService.get(REDEEM_URLS.REDEEMS_CSV, { params: transformedPayload })
  }

  static getRedeemRewards(payload: IGetRedeemRewardListRequest): Promise<WrappedResponse<IRedeemReward[]>> {
    const transformedPayload: TransformPayloadReturnT = transformPayload(payload)

    return instanceMainService.get(REDEEM_URLS.REDEEM_REWARDS, { params: transformedPayload })
  }

  static getRedeemRewardsCSV(
    // TODO Exclude<IGetRedeemRewardListRequest, 'pagination'>
    payload: any
  ): Promise<AxiosResponse<string>> {
    const transformedPayload: TransformPayloadReturnT = transformPayload(payload)

    return instanceMainService.get(REDEEM_URLS.REDEEM_REWARDS_CSV, { params: transformedPayload })
  }

  static getRedeemRewardById(id: string): Promise<WrappedResponse<IRedeemData>> {
    return instanceMainService.get(replaceUrlParams(REDEEM_URLS.REDEEM_REWARDS_BY_ID, { id }))
  }
}
